import script from "./create-forecast-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./create-forecast-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__